import { render, staticRenderFns } from "./TextHeader.vue?vue&type=template&id=3d50313e&"
import script from "./TextHeader.ts?vue&type=script&lang=ts&"
export * from "./TextHeader.ts?vue&type=script&lang=ts&"
import style0 from "./TextHeader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports